class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    // this.lineItemStatusElement = this.querySelector('.shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
    .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.bundleRemoveButtons = this.querySelectorAll('.bundle--cart-remove');

    this.bundleRemoveButtons.forEach(bundleRemove => {
      bundleRemove.addEventListener('click',this.bundleRemove.bind(this));
    });
  }

  bundleRemove() {
    const bundleItems = event.target.dataset.bundleIds.split(',');
    const qty = 0;
    const data = {
      updates: {},
      sections: "cart-drawer,cart-icon-bubble"
    }

    for (var i = 0; i < bundleItems.length; i++) {
      const IdAsString = bundleItems[i];
      data.updates[IdAsString] = qty;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      return response.json();
    })
    .then((state) => {
      cartUpdate(state);
    });
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name, event) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: "cart-drawer,cart-icon-bubble"
    });


    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartFooter = document.querySelector('#main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

      cartUpdate(parsedState);

      document.dispatchEvent(new CustomEvent("cart:change", {
        detail: {
          cart: parsedState
        }
      }));

      this.updateLiveRegions(line, parsedState.item_count);
      const lineItem =  this.querySelector(`.CartItem-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

      this.disableLoading();
    }).catch((e) => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      // this.querySelector('.cart-errors').textContent = window.cartStrings.error;
      console.log(e);
      this.disableLoading();
    });
  }

  updateLiveRegions(line, itemCount) {

    if (this.currentItemCount === itemCount) {
      this.querySelector(`.Line-item-error-${line}`)
      .querySelector('.cart-item__error-text')
      .innerHTML = window.cartStrings.quantityError.replace(
        '[quantity]',
        this.querySelector(`.quantity__input`).value
      );
    }

    this.currentItemCount = itemCount;
    // this.lineItemStatusElement.setAttribute('aria-hidden', true);

  //   const cartStatus = this.querySelector('.cart-live-region-text');
  //   cartStatus.setAttribute('aria-hidden', false);

  //   setTimeout(() => {
  //              cartStatus.setAttribute('aria-hidden', true);
  // }, 1000);
}


enableLoading(line) {
  const mainCartItems = this;
  if(mainCartItems) {
    mainCartItems.classList.add('cart__items--disabled');
  }
  this.querySelectorAll(`.CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
  document.activeElement.blur();
  // this.lineItemStatusElement.setAttribute('aria-hidden', false);
}

disableLoading() {
  this.classList.remove('cart__items--disabled');
}
}

customElements.define('cart-items', CartItems);

class CartDrawer extends MenuDrawer {
  constructor() {
    super();
    this.button = this.querySelector('.header__icon--menu');
  }
  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      if(section.id == 'cart-drawer') {
        console.log('thing');
        document.querySelector('.cart-count-bubble').innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], '.cart-count-bubble');
      }
      document.querySelector(section.id + ' ' + section.selector).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

    }));
	this.openMenuDrawer();
//     this.open();
  }

  open() {
    this.openMenuDrawer();
//     this.querySelector('summary').click();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.drawer__content'
      },
      {
        id: 'cart-icon-bubble',
        selector: '.cart-count-bubble-wrapper'
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

}

customElements.define('cart-drawer', CartDrawer);

class CartUpsells extends HTMLElement {
  constructor() {
    super();
    this.productId = parseFloat(this.getAttribute('data-upsell-id')) || false;
    this.url = this.getAttribute('data-url') || false;
    this.scroller = this.querySelector('.horizontal-scroller__upsell');
    this.gender = this.getAttribute('data-gender') || false;
    this.title = this.getAttribute('data-title') || false;
    if(this.scroller) {
      this.getUpsells();
    }
//     lazyImages();
  }
  getUpsells() {
    if(!this.url) return;
    if(!this.scroller) return;
//     const url = `/recommendations/products.json?product_id=${this.productId}&limit=10`;
    fetch(this.url)
    .then(response => response.text())
    .then(data => {

      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      /* Do stuff */

      const items = doc.querySelectorAll('.grid__item');

      let totalFound = 0;

      items.forEach(item => {
        const itemJson = JSON.parse(item.querySelector('.product-card').getAttribute('data-json'));
        const itemStyle = itemJson[0].productStyle.split(' ')[0];
        const productStyle = this.title.split(' ')[0];
        if(itemJson[0].productStyle === this.title) return true;
        if(itemJson[0].gender !== this.gender) return true;
        if(itemStyle !== productStyle) return true;
        this.scroller.appendChild(item);
        totalFound++;
      });

      if(totalFound === 0) {
        items.forEach(item => {
          const itemJson = JSON.parse(item.querySelector('.product-card').getAttribute('data-json'));
          if(itemJson[0].productStyle === this.title.replace("'",'')) return true;
          if(itemJson[0].gender !== this.gender) return true;
          this.scroller.appendChild(item);
        });
      }

      if (this.querySelectorAll('.grid__item')[0]) {
        this.classList.add('cart-upsells--loaded');
      }

      lazyImages();
    })
    .catch(error => console.log(error));
  }
}

customElements.define('cart-upsells', CartUpsells);


class GiftWrapToggle extends HTMLElement {
  constructor() {
    super();
    this.json = JSON.parse(document.querySelector('.drawer__items').getAttribute('data-json'));

    this.toggle = this.querySelector('input');
    this.toggle.addEventListener('change', this.toggleGiftWrap.bind(this));
    this.giftWrapId = parseFloat(this.toggle.getAttribute('data-gift-wrap-id'));
    this.init();
  }
  init() {
    this.toggle.checked = this.giftWrapInCart();
  }
  giftWrapInCart() {
    let inCart = false;
    this.json.forEach(item => {
      if(item.id === this.giftWrapId) {
        inCart = true;
      }
    });
    return inCart;
  }
  removeGiftWrap() {
    document.querySelector(`.cart-item[data-variant-id="${this.giftWrapId}"] cart-remove-button`).click();
  }
  toggleGiftWrap() {
    const qty = event.target.checked ? 1 : 0;
    const itemObj = {
      items: [
        {
          id: this.giftWrapId,
          quantity: qty
        }
      ]
    }
    qty === 1 ? addToCart(itemObj) : this.removeGiftWrap();
  }
}

customElements.define('gift-wrap-toggle', GiftWrapToggle);